var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoice1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6855 8.375C14.6855 7.90901 14.3078 7.53125 13.8418 7.53125C13.3758 7.53125 12.998 7.90901 12.998 8.375V19.625C12.998 20.091 13.3758 20.4688 13.8418 20.4688C14.3078 20.4688 14.6855 20.091 14.6855 19.625V8.375Z",
    fill: "url(#paint0_linear_6369_12828)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06055 15.125C9.06055 14.659 8.68279 14.2812 8.2168 14.2812C7.75081 14.2812 7.37305 14.659 7.37305 15.125V19.625C7.37305 20.091 7.75081 20.4688 8.2168 20.4688C8.68279 20.4688 9.06055 20.091 9.06055 19.625V15.125Z",
    fill: "url(#paint1_linear_6369_12828)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4668 12.0312C19.9328 12.0312 20.3105 12.409 20.3105 12.875V19.625C20.3105 20.091 19.9328 20.4688 19.4668 20.4688C19.0008 20.4688 18.623 20.091 18.623 19.625V12.875C18.623 12.409 19.0008 12.0312 19.4668 12.0312Z",
    fill: "url(#paint2_linear_6369_12828)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9061 2.46875H13.7775C11.3129 2.46874 9.37717 2.46872 7.86582 2.67192C6.31708 2.88014 5.0883 3.31555 4.12282 4.28103C3.15735 5.2465 2.72194 6.47529 2.51372 8.02403C2.31052 9.53537 2.31053 11.4711 2.31055 13.9357V14.0643C2.31053 16.5289 2.31052 18.4646 2.51372 19.976C2.72194 21.5247 3.15735 22.7535 4.12282 23.719C5.0883 24.6844 6.31708 25.1199 7.86582 25.3281C9.37716 25.5313 11.3129 25.5313 13.7774 25.5312H13.9061C16.3706 25.5313 18.3064 25.5313 19.8178 25.3281C21.3665 25.1199 22.5953 24.6844 23.5608 23.719C24.5262 22.7535 24.9617 21.5247 25.1699 19.976C25.3731 18.4646 25.3731 16.5289 25.373 14.0644V13.9357C25.3731 11.4712 25.3731 9.53536 25.1699 8.02403C24.9617 6.47529 24.5262 5.2465 23.5608 4.28103C22.5953 3.31555 21.3665 2.88014 19.8178 2.67192C18.3064 2.46872 16.3707 2.46874 13.9061 2.46875ZM5.31607 5.47427C5.91574 4.87459 6.72906 4.52743 8.09068 4.34437C9.47657 4.15804 11.2989 4.15625 13.8418 4.15625C16.3847 4.15625 18.207 4.15804 19.5929 4.34437C20.9545 4.52743 21.7679 4.87459 22.3675 5.47427C22.9672 6.07395 23.3144 6.88727 23.4974 8.24888C23.6838 9.63477 23.6855 11.4571 23.6855 14C23.6855 16.5429 23.6838 18.3652 23.4974 19.7511C23.3144 21.1127 22.9672 21.9261 22.3675 22.5257C21.7679 23.1254 20.9545 23.4726 19.5929 23.6556C18.207 23.842 16.3847 23.8438 13.8418 23.8438C11.2989 23.8438 9.47657 23.842 8.09068 23.6556C6.72906 23.4726 5.91574 23.1254 5.31607 22.5257C4.71639 21.9261 4.36923 21.1127 4.18617 19.7511C3.99984 18.3652 3.99805 16.5429 3.99805 14C3.99805 11.4571 3.99984 9.63477 4.18617 8.24888C4.36923 6.88727 4.71639 6.07395 5.31607 5.47427Z",
    fill: "url(#paint3_linear_6369_12828)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6369_12828",
    x1: 13.8418,
    y1: 2.46875,
    x2: 13.8418,
    y2: 25.5313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6369_12828",
    x1: 13.8418,
    y1: 2.46875,
    x2: 13.8418,
    y2: 25.5313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6369_12828",
    x1: 13.8418,
    y1: 2.46875,
    x2: 13.8418,
    y2: 25.5313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6369_12828",
    x1: 13.8418,
    y1: 2.46875,
    x2: 13.8418,
    y2: 25.5313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice1);
export default __webpack_public_path__ + "static/media/voice_1.b3b583f73cae359168b5b2b53c769f8e.svg";
export { ForwardRef as ReactComponent };